/**
 * `/ask` — Ask Flint home hub.
 *
 * Shows the prompt input, suggested prompts, and chat history so the
 * user lands on a purposeful screen rather than a blank chat. Navigating
 * to `/ask/$chatId` (via the home prompt or a history row) opens the
 * active chat surface.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../features/workspace/index.ts";
import { AskFlintHome } from "../../../features/ai-chat/index.ts";
import { meQueryOptions } from "../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/ask/")({
  // Restrict the route when the workspace doesn't have the Flint AI add-on
  // (migration 0107). Bounce to the workspace home — the assistant is
  // unreachable by URL too, not just hidden from the nav. Server-side re-enforces.
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    if (me?.company && !me.company.modules?.includes("ai.assistant")) {
      throw redirect({ to: "/" });
    }
  },
  component: AskHomeRoute,
});

function AskHomeRoute() {
  return (
    <WorkspaceShell
      breadcrumbs={[{ label: "Ask Flint" }]}
      disableViewportScroll
      contentClassName="mx-0 flex h-full w-full max-w-none"
    >
      <AskFlintHome />
    </WorkspaceShell>
  );
}
